// extracted by mini-css-extract-plugin
export default {"labelWrapper":"HFHIS","title":"SxIWW","value":"xeZnN","selected":"Q9g6n"};